import React, { createContext, useContext, useEffect, useState } from "react";

// Traduction par chaîne source française -> anglais. lang="fr" => clé telle quelle.
const EN = {
  // Sections & nav
  "Pilotage": "Overview", "CRM": "CRM", "Productivité": "Productivity",
  "Assistance": "Assistance", "Système": "System",
  "Aujourd'hui": "Today", "Tableau de bord": "Dashboard", "Santé & Analyses": "Health & Analytics",
  "Rentabilité": "Profitability", "Objectifs de vente": "Sales goals", "Prospects": "Leads",
  "Priorités IA": "AI priorities", "Clients": "Clients", "Contacts": "Contacts",
  "Opportunités": "Opportunities", "Pipeline de ventes": "Sales pipeline", "Soumissions": "Quotes",
  "Signature électronique": "E-signature", "Tâches": "Tasks", "Relances auto": "Auto follow-ups",
  "Calendrier": "Calendar", "Communications": "Communications", "Modèles": "Templates",
  "Documents": "Documents", "Rapports": "Reports", "Assistant IA": "AI assistant",
  "Mode chantier": "Field mode", "Support technicien": "Technician support", "Utilisateurs": "Users",
  "Journal d'audit": "Audit log", "Abonnements": "Subscriptions", "Intégrations": "Integrations",
  "Paramètres": "Settings",
  // Header / common
  "Module actif": "Active module", "Recherche globale...": "Global search...",
  "Réinitialiser démo": "Reset demo", "Notifications": "Notifications",
  "Aucune notification": "No notifications", "Se déconnecter": "Sign out",
  "Langue": "Language", "Français": "French", "Anglais": "English", "Sécurité": "Security",
  "Enregistrer": "Save", "Annuler": "Cancel", "Fermer": "Close", "Continuer": "Continue",
  "Retour": "Back", "Chargement...": "Loading...",
  // Auth
  "Se connecter": "Sign in", "Créer mon compte": "Create my account", "COURRIEL": "EMAIL",
  "MOT DE PASSE": "PASSWORD", "NOM COMPLET": "FULL NAME", "ENTREPRISE": "COMPANY",
  "Mot de passe oublié ?": "Forgot password?", "Découvrir la démo en direct": "Explore the live demo",
  "Vérification en deux étapes": "Two-step verification",
  "Entrez le code de votre application d'authentification": "Enter the code from your authenticator app",
  "Entrez le code envoyé par courriel": "Enter the code sent by email",
  "Code de vérification": "Verification code", "Vérifier": "Verify",
  "Utiliser un code de secours": "Use a backup code", "Renvoyer le code": "Resend code",
  // Billing / contract
  "Choisir ce forfait": "Choose this plan", "Forfait actuel": "Current plan",
  "Signer le contrat de service": "Sign the service contract", "Contrat de service PROGÈRE": "PROGÈRE service contract",
  "Nom du signataire": "Signer name", "Titre / fonction": "Title / role",
  "Signature (tapez votre nom)": "Signature (type your name)",
  "J'ai lu et j'accepte le contrat, les conditions générales et la politique de confidentialité.":
    "I have read and accept the contract, the terms of use and the privacy policy.",
  "Signer et payer": "Sign and pay", "Sous-total": "Subtotal", "Total à payer": "Total due",
  "Paiement sécurisé par Stripe": "Secure payment by Stripe", "Factures": "Invoices",
  "Aucune facture": "No invoices", "Payée": "Paid", "Mes contrats": "My contracts",
  // Security page
  "Authentification à deux facteurs": "Two-factor authentication",
  "Application d'authentification": "Authenticator app", "Code par courriel": "Email code",
  "Activer": "Enable", "Désactiver": "Disable", "Activée": "Enabled", "Désactivée": "Disabled",
  "Scannez ce code QR avec Google Authenticator": "Scan this QR code with Google Authenticator",
  "Codes de secours": "Backup codes",
  "Conservez ces codes en lieu sûr. Chacun ne peut servir qu'une fois.":
    "Keep these codes safe. Each can be used only once.",
  // Legal
  "Conformité & confidentialité": "Compliance & privacy",
  "Conditions générales d'utilisation": "Terms of use", "Politique de confidentialité": "Privacy policy",
  "Politique relative aux témoins": "Cookie policy", "Registre de consentement": "Consent registry",
  "Exercer vos droits (Loi 25)": "Exercise your rights (Law 25)",
  "Demande d'accès": "Access request", "Demande de rectification": "Rectification request",
  "Demande de suppression": "Deletion request", "Portabilité des données": "Data portability",
  "Exporter mes données": "Export my data", "J'accepte": "I accept",

  // Statuts (badges)
  "Actif": "Active", "Nouveau": "New", "Converti": "Converted", "Prospect": "Prospect",
  "Brouillon": "Draft", "Envoyée": "Sent", "Acceptée": "Accepted", "Refusée": "Declined",
  "À faire": "To do", "Terminé": "Done", "En cours": "In progress",
  "Haute": "High", "Moyenne": "Medium", "Basse": "Low",
  "Chaud": "Hot", "Tiède": "Warm", "Froid": "Cold",
  "Élevé": "High", "Moyen": "Medium", "Faible": "Low",
  "Ouvert": "Open", "Résolu": "Resolved", "Manager": "Manager", "Vendeur": "Sales rep",
  "Inactif": "Inactive",

  // Config CRM — titres & sous-titres
  "Gérez vos prospects et leur qualification": "Manage your leads and their qualification",
  "Votre portefeuille clients actifs": "Your active client portfolio",
  "Interlocuteurs chez vos clients": "Contacts at your clients",
  "Suivez vos opportunités de vente": "Track your sales opportunities",
  "Devis brouillons, envoyés et acceptés": "Draft, sent and accepted quotes",
  "Tâches et relances à effectuer": "Tasks and follow-ups to complete",
  "Historique des échanges clients": "History of client interactions",
  "Membres de l'équipe et rôles": "Team members and roles",
  "Billets d'assistance pour vos techniciens et clients": "Support tickets for your technicians and clients",

  // Config CRM — champs & colonnes
  "Nom": "Name", "Entreprise": "Company", "Type": "Type", "Courriel": "Email", "Statut": "Status",
  "Téléphone": "Phone", "Source": "Source", "Valeur potentielle ($)": "Potential value ($)",
  "Niveau d'intérêt": "Interest level", "Date limite de soumission": "Quote deadline",
  "Notes": "Notes", "Adresse": "Address", "Client": "Client", "Rôle": "Role",
  "Opportunité": "Opportunity", "Valeur": "Value", "Étape": "Stage", "Prob.": "Prob.",
  "Titre": "Title", "Valeur ($)": "Value ($)", "Probabilité (%)": "Probability (%)",
  "Date de clôture": "Close date", "Soumission": "Quote", "Montant": "Amount", "Montant ($)": "Amount ($)",
  "Raison (si refusée)": "Reason (if declined)", "Tâche": "Task", "Échéance": "Due date",
  "Priorité": "Priority", "Sujet": "Subject", "Date": "Date", "Contenu": "Content",
  "Catégorie": "Category", "Demandeur": "Requester", "Description": "Description",

  // Options de sélection
  "Qualification": "Qualification", "Proposition": "Proposal", "Négociation": "Negotiation",
  "Gagné": "Won", "Perdu": "Lost", "Relance": "Follow-up", "Appel": "Call", "Note": "Note",
  "Prix trop élevé": "Price too high", "Mauvais délai": "Bad timing",
  "Client a choisi un compétiteur": "Client chose a competitor", "Manque d'information": "Lack of information",
  "Mauvais suivi": "Poor follow-up", "Projet annulé": "Project cancelled", "Autre raison": "Other reason",
  "Technique": "Technical", "Facturation": "Billing", "Formation": "Training", "Autre": "Other",

  // ResourcePage — actions & états
  "Exporter": "Export", "Ajouter": "Add", "Rechercher...": "Search...", "Tous": "All",
  "Modifier": "Edit", "Supprimer": "Delete", "Fiche & historique": "Profile & history",
  "Convertir en client": "Convert to client", "Lier à PROGÈRE PUNCH": "Link to PROGÈRE PUNCH",
  "Générer PDF": "Generate PDF", "Créer projet (ERP)": "Create project (ERP)",
  "Aucun résultat": "No results", "élément(s)": "item(s)", "Rechercher": "Search",
  "Chargé": "Loaded", "Erreur": "Error", "Erreur de chargement": "Loading error",
  "Modifié": "Updated", "Ajouté": "Added", "Supprimé": "Deleted",
  "Erreur d'enregistrement": "Save error", "Export Excel généré": "Excel export generated",
  "Erreur d'export": "Export error", "Erreur PDF": "PDF error",
  "Projet créé dans PROGÈRE ERP": "Project created in PROGÈRE ERP",

  // Dashboard / Aujourd'hui / commun pages
  "Vue d'ensemble de votre activité commerciale": "Overview of your sales activity",
  "Prospects actifs": "Active leads", "Clients": "Clients", "Opportunités ouvertes": "Open opportunities",
  "Valeur du pipeline": "Pipeline value", "Soumissions en cours": "Quotes in progress",
  "Taux de conversion": "Conversion rate", "Activité récente": "Recent activity",
  "Aucune activité récente": "No recent activity", "Voir tout": "View all",
  "Votre centre de travail quotidien": "Your daily work hub",
  "Prospects chauds à contacter": "Hot leads to contact", "Relances du jour": "Today's follow-ups",
  "Rendez-vous": "Appointments", "Clients à risque": "At-risk clients", "Rien pour aujourd'hui": "Nothing for today",
  "Tableau de bord": "Dashboard", "Aujourd'hui": "Today",

  // Pipeline / opportunités
  "Glissez les cartes pour faire avancer vos opportunités": "Drag cards to move your opportunities forward",
  "Pipeline de ventes": "Sales pipeline",

  // Divers communs
  "Rechercher un client...": "Search a client...", "Aucune donnée": "No data",
  "Voir la démo": "View demo", "Réessayer": "Retry", "Confirmer": "Confirm",
  "Précédent": "Previous", "Suivant": "Next", "Terminer": "Finish",

  // Dashboard
  "Valeur pipeline": "Pipeline value", "Ventes gagnées": "Won sales", "Tâches en cours": "Tasks pending",
  "Taux conversion": "Conversion rate", "Pipeline par étape": "Pipeline by stage",
  "Nombre d'opportunités par étape de vente": "Number of opportunities per sales stage",
  "Répartition par statut": "Breakdown by status", "Aucune activité": "No activity",
  "Bienvenue": "Welcome",

  // Aujourd'hui
  "Prospects chauds": "Hot leads", "Revenus potentiels": "Potential revenue",
  "Prospects à contacter": "Leads to contact", "Relances à faire": "Follow-ups to do",
  "Soumissions à suivre": "Quotes to follow up", "Opportunités chaudes": "Hot opportunities",
  "Rendez-vous à venir": "Upcoming appointments", "Aucun prospect chaud": "No hot leads",
  "Aucune relance": "No follow-ups", "Aucune soumission en attente": "No pending quotes",
  "Aucune opportunité active": "No active opportunities", "Aucun rendez-vous": "No appointments",
  "Aucun client à risque": "No at-risk clients", "Voir →": "View →", "chaud": "hot",
  "À risque": "At risk",

  // Titres de pages personnalisées
  "Bibliothèque de modèles": "Template library", "Centre IA": "AI center",
  "Relances automatiques": "Automatic follow-ups", "Rentabilité par projet": "Profitability by project",
  "Santé de l'entreprise": "Company health", "Des forfaits pour chaque entreprise": "Plans for every business",
  // Sous-titres de pages
  "Support de vente intelligent propulsé par Claude Sonnet 4.6": "Smart sales support powered by Claude Sonnet 4.6",
  "Modèles de courriels et messages, personnalisables par l'IA": "Email and message templates, customizable by AI",
  "Vos rendez-vous et événements": "Your appointments and events",
  "Recommandations intelligentes basées sur vos données CRM": "Smart recommendations based on your CRM data",
  "Signature de contrat + paiement sécurisé Stripe · Facturation CAD avec TPS/TVQ.": "Contract signing + secure Stripe payment · CAD billing with GST/QST.",
  "Contrats, soumissions et fichiers clients": "Contracts, quotes and client files",
  "Connectez PROGÈRE CRM à votre écosystème": "Connect PROGÈRE CRM to your ecosystem",
  "Traçabilité des actions — conformité Loi 25 (Québec)": "Action traceability — Law 25 compliance (Quebec)",
  "Capturez tout sur le terrain — dictée vocale, carte d'affaires, ajout rapide": "Capture everything in the field — voice dictation, business card, quick add",
  "Suivez la progression de vos objectifs commerciaux": "Track the progress of your sales goals",
  "Préférences de l'entreprise et de votre compte": "Company and account preferences",
  "Glissez-déposez vos opportunités entre les étapes": "Drag and drop your opportunities between stages",
  "Score intelligent des prospects à prioriser aujourd'hui": "Smart lead scoring to prioritize today",
  "Analyse de la performance commerciale": "Sales performance analysis",
  "Suivi et automatisation de vos relances": "Tracking and automation of your follow-ups",
  "Vendu vs coûts réels — connecté à PROGÈRE PUNCH / ERP / COMPTA": "Sold vs real costs — connected to PROGÈRE PUNCH / ERP / COMPTA",
  "Vision globale de votre performance commerciale": "Global view of your sales performance",
  "Envoyez vos soumissions à signer et suivez leur statut": "Send your quotes for signing and track their status",
  // Pipeline / Rapports
  "Opportunité créée": "Opportunity created", "Nouvelle opportunité": "New opportunity",
  "Déplacé vers": "Moved to", "Taux de réussite": "Win rate", "Pipeline total": "Total pipeline",
  "Tendance des revenus (6 mois)": "Revenue trend (6 months)", "Prospects par source": "Leads by source",
  // Santé & Analyses
  "Nouveaux prospects (mois)": "New leads (month)", "Nouveaux clients (mois)": "New clients (month)",
  "Soumissions envoyées": "Quotes sent", "Soumissions acceptées": "Quotes accepted",
  "Soumissions perdues": "Lost quotes", "Revenus confirmés": "Confirmed revenue",
  "Prévision (pondérée)": "Forecast (weighted)", "Relances en retard": "Overdue follow-ups",
  "perdue(s)": "lost", "de valeur": "in value", "Aucune soumission perdue": "No lost quotes",
  "Suivi recommandé": "Follow-up recommended",
  // Priorités IA
  "Analyse IA": "AI analysis", "Erreur assistant IA": "AI assistant error",
  // Relances
  "Lancer les rappels": "Run reminders", "À relancer": "To follow up", "Terminées": "Completed",
  "Relance marquée terminée": "Follow-up marked completed",
  "rappels automatiques envoyés (notification interne)": "automatic reminder(s) sent (internal notification)",
  "Aucune relance en attente": "No pending follow-ups", "Aucune relance terminée": "No completed follow-ups",
  // Objectifs
  "Objectif": "Goal", "Objectif créé": "Goal created", "Aucun objectif défini": "No goals defined",
  "atteint": "achieved", "en négociation": "in negotiation",
  "Cible ($)": "Target ($)", "Période": "Period", "Responsable": "Owner", "Module": "Module",
  // Assistant IA
  "Bonjour ! Je suis votre assistant de vente PROGÈRE IA. Posez-moi une question sur vos prospects, clients ou soumissions.":
    "Hello! I'm your PROGÈRE AI sales assistant. Ask me anything about your leads, clients or quotes.",
  "Quels prospects dois-je contacter en priorité aujourd'hui ?": "Which leads should I contact first today?",
  "Quelle stratégie pour relancer mes soumissions envoyées ?": "What strategy to follow up on my sent quotes?",
  "Quels clients sont à risque et pourquoi ?": "Which clients are at risk and why?",
  "Courriel de relance": "Follow-up email", "Texto de suivi": "Follow-up text", "Message LinkedIn": "LinkedIn message",
  "Script d'appel": "Call script", "Assistant PROGÈRE IA": "PROGÈRE AI assistant", "Rédaction IA": "AI writing",
  "Générez un message personnalisé pour un client.": "Generate a personalized message for a client.",
  "Nom du client / entreprise": "Client / company name", "Générer": "Generate", "Copier": "Copy", "Copié": "Copied",
  "Posez votre question...": "Ask your question...", "Désolé, une erreur est survenue.": "Sorry, an error occurred.",
  "Indiquez un nom de client": "Enter a client name", "Erreur de génération": "Generation error",
  // Modèles
  "Personnaliser (IA)": "Personalize (AI)", "Générer le message": "Generate the message",
  "Indiquez un client": "Enter a client", "Erreur IA": "AI error", "Personnaliser": "Personalize",
  // Calendrier — mois & jours
  "Janvier": "January", "Février": "February", "Mars": "March", "Avril": "April", "Mai": "May",
  "Juin": "June", "Juillet": "July", "Août": "August", "Septembre": "September",
  "Octobre": "October", "Novembre": "November", "Décembre": "December",
  "Jan": "Jan", "Fév": "Feb", "Avr": "Apr", "Jui": "Jun", "Aoû": "Aug", "Déc": "Dec",
  "Dim": "Sun", "Lun": "Mon", "Mar": "Tue", "Mer": "Wed", "Jeu": "Thu", "Ven": "Fri", "Sam": "Sat",
  "Rendez-vous": "Appointment", "À venir": "Upcoming", "Aucun événement": "No events",
  "Rendez-vous ajouté": "Appointment added", "Visite": "Visit", "Démo": "Demo",
  "Lieu": "Location", "Début": "Start", "Fin": "End",
  // Documents
  "Téléverser": "Upload", "Document téléversé": "Document uploaded", "Erreur de téléversement": "Upload error",
  "Supprimer ce document ?": "Delete this document?", "Non lié": "Not linked", "Aucun document": "No documents",
  // Intégrations
  "Connecté": "Connected", "Non connecté": "Not connected", "Déconnecter": "Disconnect",
  "Connecter": "Connect", "déconnecté": "disconnected", "connecté": "connected",
  // Guide IA vocal & Centre Maître
  "Guide de la page": "Page guide", "Guide IA": "AI guide", "Écouter le guide": "Listen to guide",
  "Arrêter": "Stop", "Aide IA": "AI help", "Centre Maître": "Master Center",
  "Vue d'ensemble": "Overview", "Billets de support": "Support tickets", "Clients & organisations": "Clients & organizations",
  "Problèmes techniques": "Technical issues", "Revenu total": "Total revenue",
  "Abonnements actifs": "Active subscriptions", "Organisations": "Organizations",
  "Billets ouverts": "Open tickets", "Erreurs ouvertes": "Open errors", "Répondre": "Reply",
  "Marquer résolu": "Mark resolved", "Aucun billet": "No tickets",
  "Aucun problème": "No issues", "Signaler un problème": "Report an issue",
  "Réponse envoyée": "Reply sent", "Forfait": "Plan",
  "Signalement envoyé": "Report sent", "Envoyer": "Send",
  "Décrivez le problème rencontré. Le propriétaire le recevra dans le Centre Maître.": "Describe the issue you encountered. The owner will receive it in the Master Center.",
};

const LangContext = createContext(null);

function detectLang() {
  const saved = localStorage.getItem("pg_lang");
  if (saved === "fr" || saved === "en") return saved;
  return "fr";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);
  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem("pg_lang", lang);
  }, [lang]);
  // Pré-sélection auto selon le pays (géo-IP) tant que l'utilisateur n'a pas choisi manuellement.
  useEffect(() => {
    if (localStorage.getItem("pg_lang_user_set") === "1") return;
    let cancelled = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/geo/detect-lang`)
      .then((r) => r.json())
      .then((d) => {
        if (cancelled || localStorage.getItem("pg_lang_user_set") === "1") return;
        if (d && (d.lang === "fr" || d.lang === "en")) setLangState(d.lang);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  const setLang = (l) => { localStorage.setItem("pg_lang_user_set", "1"); setLangState(l); };
  const t = (s) => (lang === "en" ? EN[s] || s : s);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext) || { lang: "fr", setLang: () => {}, t: (s) => s };
